export interface BridgeConfig {
    product_id: string;
    type: string;
    action: null;
    data: null;
    correlation_id: string;
    plugin: string;
}

export enum ChattyContextEvent {
    SEND_CONTEXT = 'chattyReceiveContext',
    RECEIVE_CONTEXT = 'chattySendContext',
    BACKGROUND_UPDATE_CONTEXT = 'c24-chatty-connection-info',
}

export interface CsCodeUpdateRequest {
    cs_code: string;
}

export interface CsCodeUpdateResponse {
    status: 'success' | 'error';
    gratbar?: string;
    csCode?: string;
    isValidGhkCsCode?: boolean;
    target?: string;
}
